<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>home</mat-icon>
    </div>
    <div class="rf-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" [message]="isEdit ? 'Cargando inversión…' : 'Preparando formulario…'"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Guardando inversión…' : 'Creando inversión…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="rf-load-error">
        <mat-icon>error</mat-icon>
        <span>{{ isEdit ? 'No se pudo cargar la inversión inmobiliaria.' : 'No se pudieron cargar los datos del formulario.' }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body rf-body" [formGroup]="form">
      <div class="rf-layout">
        <div class="rf-main">

          <section class="rf-section">
            <span class="cf-dlg-section__label">Datos de la inversión</span>

            <div class="cf-dlg-row">
              <div class="cf-field--required" [class.cf-field--invalid]="hasError('provider')">
                <div class="rf-provider">
                  <div class="rf-provider__field">
                    <app-autocomplete [control]="providerControl" [config]="{ label: 'Proveedor', placeholder: 'Buscar proveedor…', options: providers, autoSelectSingle: true }">
                    </app-autocomplete>
                  </div>
                  <button mat-stroked-button type="button" class="cf-btn rf-provider__btn" (click)="newProvider()" [disabled]="reloadingProviders" title="Nuevo proveedor">
                    <mat-icon>person_add</mat-icon> Nuevo
                  </button>
                </div>
                <div class="cf-field__error" *ngIf="hasError('provider')"><mat-icon>error</mat-icon> {{ errors.provider }}</div>
                <div class="rf-hint" *ngIf="reloadingProviders">Actualizando proveedores…</div>
              </div>

              <div class="cf-field--required" [class.cf-field--invalid]="hasError('account')">
                <app-autocomplete [control]="accountControl" [config]="{ label: 'Tipo de inversión (cuenta)', placeholder: 'Seleccionar cuenta…', options: accounts, autoSelectSingle: true, strict: true }">
                </app-autocomplete>
                <div class="cf-field__error" *ngIf="hasError('account')"><mat-icon>error</mat-icon> {{ errors.account }}</div>
                <div class="rf-hint" *ngIf="!accounts.length">No tienes cuentas contables 220 / 221.</div>
              </div>
            </div>

            <div class="cf-field--required" [class.cf-field--invalid]="hasError('investmentDescription')">
              <app-field [control]="investmentDescriptionControl" [config]="{ label: 'Descripción', required: true, maxLength: descriptionMax }"></app-field>
              <div class="cf-field__error" *ngIf="hasError('investmentDescription')"><mat-icon>error</mat-icon> {{ errors.investmentDescription }}</div>
            </div>

            <div class="cf-dlg-row">
              <div class="cf-field--required" [class.cf-field--invalid]="hasError('investmentDate')">
                <app-date [control]="investmentDateControl" [config]="{ label: 'Fecha de compra', required: true }"></app-date>
                <div class="cf-field__error" *ngIf="hasError('investmentDate')"><mat-icon>error</mat-icon> {{ errors.investmentDate }}</div>
              </div>

              <div class="cf-field--required" [class.cf-field--invalid]="hasError('usage')">
                <app-autocomplete [control]="usageControl" [config]="{ label: 'Uso', placeholder: 'Seleccionar uso…', options: usageOptions, required: true, strict: true }"></app-autocomplete>
                <div class="cf-field__error" *ngIf="hasError('usage')"><mat-icon>error</mat-icon> {{ errors.usage }}</div>
              </div>
            </div>

            <app-checkbox class="rf-toggle" [formControl]="companyPremisesControl" [config]="{ label: 'Local / oficina de la empresa' }"></app-checkbox>
          </section>

          <section class="rf-section">
            <span class="cf-dlg-section__label">Amortización</span>
            <div class="rf-grid-4">
              <app-field [control]="amortizationTypeControl" [config]="{ label: 'Tipo de amortización', readonly: true }"></app-field>

              <div class="cf-field--required" [class.cf-field--invalid]="hasError('maximumLinearCoefficient')">
                <app-field [control]="maximumLinearCoefficientControl" [config]="{ label: 'Coeficiente lineal máximo', type: 'number', required: true, suffix: '%', min: 0, max: 100, step: 1, inputmode: 'numeric' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('maximumLinearCoefficient')"><mat-icon>error</mat-icon> {{ errors.maximumLinearCoefficient }}</div>
              </div>

              <div class="cf-field--required" [class.cf-field--invalid]="hasError('maximumPeriod')">
                <app-field [control]="maximumPeriodControl" [config]="{ label: 'Periodo máximo', type: 'number', required: true, suffix: 'años', min: 0, max: 100, step: 1, inputmode: 'numeric' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('maximumPeriod')"><mat-icon>error</mat-icon> {{ errors.maximumPeriod }}</div>
              </div>

              <div [class.cf-field--invalid]="hasError('residualValue')">
                <app-field [control]="residualValueControl" [config]="{ label: 'Valor residual', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('residualValue')"><mat-icon>error</mat-icon> {{ errors.residualValue }}</div>
              </div>
            </div>
          </section>

          <section class="rf-section">
            <span class="cf-dlg-section__label">Valores de compra y catastrales</span>
            <div class="rf-grid-3">
              <div [class.cf-field--invalid]="hasError('purchaseValueConstruction')">
                <app-field [control]="purchaseValueConstructionControl" [config]="{ label: 'Valor de compra construcción', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('purchaseValueConstruction')"><mat-icon>error</mat-icon> {{ errors.purchaseValueConstruction }}</div>
              </div>

              <div [class.cf-field--invalid]="hasError('landPurchaseValue')">
                <app-field [control]="landPurchaseValueControl" [config]="{ label: 'Valor de compra suelo', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('landPurchaseValue')"><mat-icon>error</mat-icon> {{ errors.landPurchaseValue }}</div>
              </div>

              <div [class.cf-field--invalid]="hasError('cadastralReference')">
                <app-field [control]="cadastralReferenceControl" [config]="{ label: 'Referencia catastral', maxLength: cadastralReferenceMax }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('cadastralReference')"><mat-icon>error</mat-icon> {{ errors.cadastralReference }}</div>
              </div>

              <div [class.cf-field--invalid]="hasError('cadastralValue')">
                <app-field [control]="cadastralValueControl" [config]="{ label: 'Valor catastral', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('cadastralValue')"><mat-icon>error</mat-icon> {{ errors.cadastralValue }}</div>
              </div>

              <div [class.cf-field--invalid]="hasError('cadastralValueConstruction')">
                <app-field [control]="cadastralValueConstructionControl" [config]="{ label: 'Valor catastral construcción', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('cadastralValueConstruction')"><mat-icon>error</mat-icon> {{ errors.cadastralValueConstruction }}</div>
              </div>

              <div [class.cf-field--invalid]="hasError('cadastralValueLand')">
                <app-field [control]="cadastralValueLandControl" [config]="{ label: 'Valor catastral suelo', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('cadastralValueLand')"><mat-icon>error</mat-icon> {{ errors.cadastralValueLand }}</div>
              </div>
            </div>
          </section>

          <section class="rf-section">
            <span class="cf-dlg-section__label">Importes e impuestos</span>
            <div class="cf-dlg-row">
              <div class="cf-field--required" [class.cf-field--invalid]="hasError('base')">
                <app-field [control]="baseControl" [config]="{ label: 'Total (sin impuestos)', type: 'number', required: true, suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="hasError('base')"><mat-icon>error</mat-icon> {{ errors.base }}</div>
              </div>

              <app-multi-select-autocomplete [control]="taxesControl" [config]="taxesConfig"></app-multi-select-autocomplete>
            </div>

            <div class="rf-totals">
              <div class="rf-totals__item">
                <span class="rf-totals__label">Base</span>
                <span class="rf-totals__value">{{ baseAmount | number:'1.2-2' }} €</span>
              </div>
              <div class="rf-totals__item">
                <span class="rf-totals__label">Impuestos</span>
                <span class="rf-totals__value">{{ taxAmount | number:'1.2-2' }} €</span>
              </div>
              <div class="rf-totals__item rf-totals__item--accent">
                <span class="rf-totals__label">Total</span>
                <span class="rf-totals__value">{{ total | number:'1.2-2' }} €</span>
              </div>
            </div>
          </section>

          <section class="rf-section" *ngIf="isProjectEnable">
            <span class="cf-dlg-section__label">Asociaciones/Fundaciones</span>
            <app-autocomplete [control]="form.get('project')" [config]="{
                label: 'Proyecto',
                placeholder: 'Seleccionar proyecto...',
                options: projects
              }">
            </app-autocomplete>
            <ng-container *ngIf="isNonprofit">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Partida</mat-label>
                <mat-select formControlName="clasificadorPartida" (selectionChange)="onPartidaChange()">
                  <mat-option [value]="null">Sin partida</mat-option>
                  <mat-option *ngFor="let partida of clasificadorCatalog" [value]="partida.nombre">{{ partida.nombre }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="form.get('clasificadorPartida').value && subpartidasOf().length" appearance="outline" class="w-100">
                <mat-label>Subpartida</mat-label>
                <mat-select formControlName="clasificadorSubpartida" (selectionChange)="onSubpartidaChange()">
                  <mat-option [value]="null">Sin subpartida</mat-option>
                  <mat-option *ngFor="let sub of subpartidasOf()" [value]="sub.nombre">{{ sub.nombre }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="form.get('clasificadorSubpartida').value && familiasOf().length" appearance="outline" class="w-100">
                <mat-label>Familia</mat-label>
                <mat-select formControlName="clasificadorFamilia">
                  <mat-option [value]="null">Sin familia</mat-option>
                  <mat-option *ngFor="let familia of familiasOf()" [value]="familia">{{ familia }}</mat-option>
                </mat-select>
              </mat-form-field>

              <app-autocomplete *ngIf="form.get('project').value" [control]="form.get('grant')" [config]="{
                  label: 'Financiación', placeholder: 'Seleccionar financiación...', options: grantOptions }">
              </app-autocomplete>
            </ng-container>
          </section>
        </div>

        <aside class="rf-side">
          <section class="rf-section">
            <span class="cf-dlg-section__label">Documento adjunto</span>
            <div class="rf-file-actions">
              <input #fileInput class="rf-file-input" type="file" accept=".pdf,.png,.jpg,.jpeg" (change)="onFileSelected($event)">
              <button mat-stroked-button type="button" class="cf-btn" (click)="fileInput.click()" [disabled]="loadingFile">
                <mat-icon>file_upload</mat-icon> Subir
              </button>
              <button mat-stroked-button type="button" class="cf-btn" (click)="pickFromFiles()" [disabled]="loadingFile">
                <mat-icon>folder</mat-icon> Desde Ficheros
              </button>
              <button *ngIf="hasFile" mat-stroked-button type="button" class="cf-btn rf-btn--danger" (click)="removeFile()" [disabled]="loadingFile">
                <mat-icon>delete</mat-icon> Quitar
              </button>
            </div>

            <app-loading-state *ngIf="loadingFile" [compact]="true" message="Cargando documento…"></app-loading-state>

            <ng-container *ngIf="!loadingFile">
              <div class="rf-file-preview" *ngIf="hasFile && (imageUrl || pdfUrl); else noFile">
                <img *ngIf="isImage && imageUrl" [src]="imageUrl" alt="Documento de la inversión">
                <iframe *ngIf="isPdf && pdfUrl" [src]="pdfUrl" title="Documento de la inversión"></iframe>
              </div>
              <ng-template #noFile>
                <div class="rf-file-empty">
                  <mat-icon>attach_file</mat-icon>
                  <span *ngIf="!hasFile">Adjunta la escritura o la factura de compra (PDF, PNG o JPG).</span>
                  <span *ngIf="hasFile">Documento adjunto sin vista previa.</span>
                </div>
              </ng-template>
            </ng-container>
          </section>
        </aside>
      </div>

      <div class="cf-dlg-mismatch rf-save-error" *ngIf="saveError">
        <mat-icon>error</mat-icon>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="loadingFile">
        <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear inversión' }}
      </button>
    </div>
  </ng-container>
</div>
